export default "__VITE_ASSET__C3lN7Ahc__"